
import { stateMerge } from 'vue-object-merge';

export default {
    namespaced: true,
    state: {
        colours: {
        },
        logo: {
            usePrimaryBg: true,
        },
        background: {
            useColourOverlay: false,
        },
        schemeName: '',
        homepageCaveat: '',
        schemeDocs: [],
        importantForms: [],
        modeller: {},
        modellerOverrides: {},
    },
    getters: {
        clientConfig: s => s,
        // Replace 'the' with 'The' if 'The' is part of the scheme name - 'The NRM Pension fund' fix
        formatTheSchemeName: (scheme) => {
            const schemeName = scheme.schemeName;
            if (!schemeName) {
                return '';
            }
            if (schemeName.startsWith('The ')) {
                return schemeName;
            }
            return `the ${schemeName}`;
        },
    },
    mutations: {
        setClientConfig (state, payload) {
            stateMerge(state, payload);
        },
    },
    actions: {
        setClientConfig ({ commit }, payload) {
            commit('setClientConfig', payload);
            if (payload.news !== undefined) {
                commit('news/addExtraNews', payload.news, { root: true });
            }
        },
    },
};
